import script from "./ContatoreTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoreTable2.vue?vue&type=script&setup=true&lang=js"

import "./ContatoreTable2.vue?vue&type=style&index=0&id=5700c5fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5700c5fa"]])

export default __exports__